var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasFloat)?_c('div',{staticClass:"exchange-float",class:{ 'is-collapsed': _vm.collapsed },on:{"click":_vm.handleClick}},[_c('img',{staticClass:"exchange-float-img",attrs:{"src":_vm.floatInfo.openFloatImage,"alt":"兑换浮标"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }